<div
  *ngIf="!data"
  class="absolute bg-white flex items-center justify-center w-screen h-screen z-20"
>
  <div class="flex justify-center items-center space-x-1 text-sm text-gray-700">
    <svg
      fill="none"
      class="w-24 h-24 animate-spin"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
        fill="currentColor"
        fill-rule="evenodd"
      />
    </svg>

    <div>Chargement ...</div>
  </div>
</div>
<div class="flex flex-col px-8 h-full">
  <div class="flex justify-between mb-4 h-1/4">
    <div class="flex w-full gap-4 p-4 mt-10">
      <div
        class="overflow-auto flex flex-col w-1/3 border-2 rounded-md px-5 py-2"
      >
        <div class="flex justify-between mb-4">
          <span class="text-sm mt-2 text-gray-400">Sociétés</span>
          <span
            class="text-sm mt-2 text-blue-600 cursor-pointer"
            (click)="updateFilter('soc')"
          >
            réinitialiser</span
          >
        </div>
        <mat-checkbox
          class="text-gray-700 font-bold"
          [color]="'warn'"
          *ngFor="let soc of listSoc"
          (change)="checkFilter($event.checked, soc.code, 'soc')"
          [checked]="exsistInFilter(soc.code)"
          >{{ soc.code }}</mat-checkbox
        >
      </div>
      <div
        class="overflow-auto flex flex-col w-1/3 border-2 rounded-md px-5 py-2"
      >
        <div class="flex justify-between mb-4">
          <span class="text-sm mt-2 text-gray-400">Banques</span>
          <span
            class="text-sm mt-2 text-blue-600 cursor-pointer"
            (click)="updateFilter('bank')"
          >
            réinitialiser</span
          >
        </div>
        <mat-checkbox
          class="text-gray-700 font-bold"
          [color]="'warn'"
          [checked]="exsistInFilter(bank.Nom)"
          *ngFor="let bank of listBanks"
          (change)="checkFilter($event.checked, bank.Nom, 'bank')"
          >{{ bank.Nom }}</mat-checkbox
        >
      </div>
    </div>
    <div class="flex flex-col justify-between">
      <div class="flex p-4 pr-0 mt-10 items-baseline gap-4">
        <mat-form-field appearance="outline">
          <mat-label>Date min</mat-label>
          <input
            matInput
            [min]="minDateAllowed"
            [matDatepicker]="pickerMin"
            [(ngModel)]="minDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerMin"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerMin></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Date max</mat-label>
          <input matInput [matDatepicker]="pickerMax" [(ngModel)]="maxDate" />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerMax"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerMax></mat-datepicker>
        </mat-form-field>
        <button
          mat-flat-button
          class="bg-blue-500 text-white"
          (click)="setupLevel4()"
        >
          Mise a jour
        </button>
      </div>
      <div class="gap-4 flex justify-between pr-6">
        <div class="flex gap-2">
          <button
            (click)="changeSorType('day')"
            mat-flat-button
            [class]="
              sortBy == 'day'
                ? 'bg-green-600 text-white'
                : 'text-green-600 border border-green-600'
            "
          >
            Par jour
          </button>
          <button
            (click)="changeSorType('mounth')"
            mat-flat-button
            [class]="
              sortBy == 'mounth'
                ? 'bg-green-600 text-white'
                : 'text-green-600 border border-green-600'
            "
          >
            Par mois
          </button>
        </div>

        <div class="flex gap-2">
          <button
            (click)="setMinDate(-1)"
            mat-flat-button
            [class]="
              minDate <= minDateAllowed
                ? 'opacity-70'
                : 'bg-blue-600 text-white'
            "
            [disabled]="minDate <= minDateAllowed"
          >
            Precendent
          </button>
          <button
            (click)="setMinDate(1)"
            mat-flat-button
            class="bg-blue-600 text-white"
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full ">
    <!-- <div class="w-full pt-4">
      <app-tree-table #tableSoc
      *ngIf="dateSocieteFirstTable.length != 0 && showTable"
      [configs]="configs"
      [(level)]="level"
      [level4]="dateSocieteFirstTable"
      (cellSelected)="presentDetailsModal($event)"
      [(dataSource)]="dataSourceFirstTable"
      [allowIcon]="true"
      [hideExpand]="true"
      [showAvant]="false"
      [hideFirstcol]="true"
    ></app-tree-table>
    </div> -->
    <!-- <span class="flex justify-center items-center p-2 font">Encaissment / Décaissement</span> -->
    <app-tree-table
      *ngIf="dateEncaismenmat.length != 0 && showTable"
      [configs]="configs"
      [(level)]="level"
      [showAvant]="false"
      [level4]="dateEncaismenmat"
      (cellSelected)="presentDetailsModal($event)"
      [(dataSource)]="dataSecondeTable"
    ></app-tree-table>
    <!-- <span class="flex justify-center items-center p-2" >Societe</span> -->
  </div>
  <div class="w-full pt-4">
    <app-tree-table
    *ngIf="dateSociete.length != 0 && showTable"
    [configs]="configs"
    [(level)]="level"
    [level4]="dateSociete"
    (cellSelected)="presentDetailsModal($event)"
    [(dataSource)]="dataLastTable"
    [allowIcon]="true"
    [showAvant]="false"
  ></app-tree-table>
  </div>

</div>
<ng-template #details>
  <ng-container *ngIf="insightData.length > 0">
    <div class="flex justify-between">
      <div>
        <div class="text-2xl text-gray-700 font-bold">
          {{ dateDetailsMin | date: "dd-MM-YYYY" }}
          <ng-container *ngIf="dateDetailsMax">
            ➡ {{ dateDetailsMax | date: "dd-MM-YYYY" }}
          </ng-container>
        </div>
        <div class="flex gap-2 text-gray-700 font-bold items-baseline">
          <div
            [class]="
              insightData[0].nature == 1 ? 'text-green-700' : 'text-red-500'
            "
            class="text-xl"
          >
            {{ insightData[0].nature == 1 ? "Encaissement" : "Décaissement" }}
          </div>
          <span>></span>
          <div class="text-lg">{{ insightData[0].soc }}</div>
          <span>></span>
          <div class="text-lg">{{ insightData[0].banque }}</div>
          <span>></span>
          <div>{{ insightData[0].type }}</div>
        </div>
      </div>
      <mat-icon class="cursor-pointer" (click)="closeDialog()">close</mat-icon>
    </div>
    <br />
    <div class="flex flex-col" style="width: 70vw" *ngIf="false">
      <div
        class="p-4 font-bold flex gap-4 bg-gray-800 text-white justify-around"
      >
        <div *ngFor="let key of insightDataKeys" class="w-1/6">{{ key }}</div>
      </div>
      <div class="flex flex-col overflow-auto" style="max-height: 50vh">
        <div
          *ngFor="let detail of insightData; index as i"
          [class]="i % 2 == 0 ? 'bg-gray-200' : ''"
          class="p-4 font-bold flex gap-4 justify-around"
        >
          <ng-container *ngFor="let key of insightDataKeys">
            <div *ngIf="key == 'Montant'" class="w-1/6">
              {{ detail[key] | number: ".3-3":"fr" }}
            </div>
            <div *ngIf="key == 'dateEch'" class="w-1/6">
              {{ detail[key] | date: "dd-MM-YYYY" }}
            </div>
            <div *ngIf="key != 'Montant' && key != 'dateEch'" class="w-1/6">
              {{ detail[key] }}
            </div>
          </ng-container>
          <!-- <div class="w-1/2">{{ detail.montant | number: ".3-3":"fr" }}</div> -->
        </div>
      </div>
    </div>
    <ng-container *ngIf="data && insightData && insightData.length > 0">
      <div style="width: 75vw; height: 70vh">
        <app-table #tableComponent [source]="detailsData"></app-table>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
